(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["colour-selector"] && !Shopify.designMode) return;
  try {
    (function() {
    function lockScroll() {
      window.ScrollLock?.lock({ background: false, restoreScroll: true });
    }

    function unlockScroll() {
      window.ScrollLock?.unlock({ background: false, restoreScroll: true });
    }

    function initColourModals() {
      document.addEventListener('click', (e) => {
        // Close any open desktop dropdowns when clicking outside
        const openDropdowns = document.querySelectorAll('.colour-dropdown--desktop[open]');
        openDropdowns.forEach((dropdown) => {
          if (!dropdown.contains(e.target)) {
            dropdown.removeAttribute('open');
          }
        });

        // Handle desktop dropdown option click - close dropdown
        const desktopOption = e.target.closest('.colour-dropdown__option');
        if (desktopOption) {
          const details = desktopOption.closest('details');
          if (details) {
            details.removeAttribute('open');
          }
          // Navigation handled by <a> tag href
          return;
        }

        // Handle mobile trigger click
        const trigger = e.target.closest('[data-colour-mobile-trigger]');
        if (trigger) {
          const wrapper = trigger.closest('[data-colour-dropdown-wrapper]');
          const modal = wrapper?.querySelector('[data-colour-modal]');
          if (modal) {
            lockScroll();
            modal.showModal();
            requestAnimationFrame(() => modal.classList.add('is-open'));
            if (document.activeElement) document.activeElement.blur();
          }
          return;
        }

        // Handle close button click
        const closeBtn = e.target.closest('[data-colour-modal-close]');
        if (closeBtn) {
          const modal = closeBtn.closest('[data-colour-modal]');
          if (modal) {
            unlockScroll();
            modal.classList.remove('is-open');
            modal.addEventListener('transitionend', () => modal.close(), { once: true });
          }
          return;
        }

        // Handle backdrop click
        if (e.target.matches('[data-colour-modal]')) {
          unlockScroll();
          e.target.classList.remove('is-open');
          e.target.addEventListener('transitionend', () => e.target.close(), { once: true });
          return;
        }

        // Handle modal option click - navigate to product URL
        const optionBtn = e.target.closest('[data-colour-modal-option]');
        if (optionBtn) {
          const url = optionBtn.dataset.colourUrl;
          const modal = optionBtn.closest('[data-colour-modal]');

          if (modal) {
            unlockScroll();
            modal.classList.remove('is-open');
            modal.addEventListener('transitionend', () => {
              modal.close();
              if (url) window.location.href = url;
            }, { once: true });
          } else if (url) {
            window.location.href = url;
          }
          return;
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initColourModals);
    } else {
      initColourModals();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-selector"] && !Shopify.designMode) return;
  try {
    (function() {
    function lockScroll() {
      window.ScrollLock?.lock({ background: false, restoreScroll: true });
    }

    function unlockScroll() {
      window.ScrollLock?.unlock({ background: false, restoreScroll: true });
    }

    /*
     * Sync ancillary UI (dropdown summary, mobile modal selected state, color
     * legend) for an option group based on which radio input is currently
     * checked. The visual selected state of the radio's adjacent label is
     * handled in CSS via :checked.
     *
     * Runs on every variant-selector change so any consumer (PDP, quick-shop,
     * shop-the-look) gets consistent UI even when no server re-fetch happens.
     */
    function syncOptionGroupUI(input) {
      const fieldset = input.closest('.variant-selector-group');
      if (!fieldset) return;

      const checkedInput = fieldset.querySelector('.variant-selector-input:checked');
      if (!checkedInput) return;

      const selectedValue = checkedInput.value;

      const summaryLabels = fieldset.querySelectorAll('.variant-dropdown__summary-label');
      for (const label of summaryLabels) {
        label.textContent = selectedValue;
      }

      const isColor = fieldset.hasAttribute('data-variant-option-color');
      if (isColor) {
        const checkedOptionLabel = fieldset.querySelector(`label[for="${CSS.escape(checkedInput.id)}"]`);
        const sourceSwatch = checkedOptionLabel?.querySelector('.variant-dropdown__swatch');
        const sourceStyle = sourceSwatch?.getAttribute('style') || '';
        const summarySwatches = fieldset.querySelectorAll('.variant-dropdown__summary-swatch');
        for (const swatch of summarySwatches) {
          if (sourceStyle) {
            swatch.setAttribute('style', sourceStyle);
          } else {
            swatch.removeAttribute('style');
          }
        }

        const legendName = fieldset.querySelector('[data-variant-option-selected-name]');
        if (legendName) legendName.textContent = selectedValue;
      }

      const modalOptions = fieldset.querySelectorAll('[data-variant-modal-option]');
      for (const option of modalOptions) {
        const isSelected = option.dataset.syncsWith === checkedInput.id;
        option.classList.toggle('variant-modal__option--selected', isSelected);
        option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      }
    }

    function initVariantUiSync() {
      document.addEventListener('change', (e) => {
        const input = e.target.closest('.variant-selector-input');
        if (!input) return;
        syncOptionGroupUI(input);
      });
    }

    function initVariantMobileModals() {
      document.addEventListener('click', (e) => {
        // Close any open desktop dropdowns when clicking outside
        const openDropdowns = document.querySelectorAll('.variant-dropdown--desktop[open]');
        openDropdowns.forEach((dropdown) => {
          if (!dropdown.contains(e.target)) {
            dropdown.removeAttribute('open');
          }
        });

        // Handle mobile trigger click
        const trigger = e.target.closest('[data-variant-mobile-trigger]');
        if (trigger) {
          const wrapper = trigger.closest('[data-variant-dropdown-wrapper]');
          const modal = wrapper?.querySelector('[data-variant-modal]');
          if (modal) {
            lockScroll();
            modal.showModal();
            requestAnimationFrame(() => modal.classList.add('is-open'));
            if (document.activeElement) document.activeElement.blur();
          }
          return;
        }

        // Handle close button click
        const closeBtn = e.target.closest('[data-variant-modal-close]');
        if (closeBtn) {
          const modal = closeBtn.closest('[data-variant-modal]');
          if (modal) {
            unlockScroll();
            modal.classList.remove('is-open');
            modal.addEventListener('transitionend', () => modal.close(), { once: true });
          }
          return;
        }

        // Handle backdrop click
        if (e.target.matches('[data-variant-modal]')) {
          unlockScroll();
          e.target.classList.remove('is-open');
          e.target.addEventListener('transitionend', () => e.target.close(), { once: true });
          return;
        }

        // Handle modal option click
        const optionBtn = e.target.closest('[data-variant-modal-option]');
        if (optionBtn) {
          const syncWithId = optionBtn.dataset.syncsWith;
          const clickedNotifyMe = e.target.closest('.variant-modal__notify');
          const modal = optionBtn.closest('[data-variant-modal]');

          // Close modal first
          if (modal) {
            unlockScroll();
            modal.classList.remove('is-open');
            modal.addEventListener('transitionend', () => modal.close(), { once: true });
          }

          // Trigger desktop input change after modal closes
          setTimeout(() => {
            const desktopInput = document.getElementById(syncWithId);
            if (desktopInput) {
              desktopInput.checked = true;
              desktopInput.dispatchEvent(new Event('change', { bubbles: true }));
            }

            // Only trigger Boost notify if they clicked specifically on "Notify Me"
            if (clickedNotifyMe) {
              setTimeout(() => {
                const boostNotifyBtn = document.getElementById('boost-sd__bis-notify-me-button');
                if (boostNotifyBtn) {
                  boostNotifyBtn.click();
                }
              }, 150);
            }
          }, 50);
          return;
        }

        // Handle desktop dropdown option click
        const dropdownOption = e.target.closest('.variant-dropdown__option');
        if (dropdownOption && !e.target.closest('.variant-dropdown__notify')) {
          const details = dropdownOption.closest('details');
          const wrapper = dropdownOption.closest('[data-variant-dropdown-wrapper]');
          const trigger = wrapper?.querySelector('.variant-dropdown__summary');

          // Close dropdown
          if (details) {
            details.removeAttribute('open');
          }

          // Add loading state to trigger
          if (trigger) {
            trigger.classList.add('variant-dropdown__summary--loading');
          }
        }

        // Handle notify me click in dropdown (desktop)
        const notifySpan = e.target.closest('.variant-dropdown__notify');
        if (notifySpan) {
          e.preventDefault();
          e.stopPropagation();

          // Find the associated input and select it first
          const optionLabel = notifySpan.closest('.variant-dropdown__option');
          const inputId = optionLabel?.getAttribute('for');
          if (inputId) {
            const input = document.getElementById(inputId);
            if (input) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }

          // Close dropdown
          const details = notifySpan.closest('details');
          if (details) {
            details.removeAttribute('open');
          }

          // Trigger Boost notify after variant updates
          setTimeout(() => {
            const boostNotifyBtn = document.getElementById('boost-sd__bis-notify-me-button');
            if (boostNotifyBtn) {
              boostNotifyBtn.click();
            }
          }, 200);
        }
      });
    }

    function init() {
      initVariantMobileModals();
      initVariantUiSync();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
